import {toURL} from "../../reducers/util";
import {LabelAndKey} from "./types/LabelAndKey";
import {CONFIG} from "../../util/config";

export const apiFetchOptions = (fetchURL: string, setOptions: (labelAndKeys:LabelAndKey[]) => void): () => void => {
    let isMounted = true
    fetch(toURL(fetchURL), {
        ...(CONFIG.isDev && { credentials: 'include' })
    })
        .then(response => response.json())
        .then(body => {
            const optionsData = body.map((i: { code: string, name: string, opt?: any }) => ({
                key: i.code,
                label: i.name,
                opt: isJson(i.opt) ? JSON.parse(i.opt) : i.opt
            }))
            if (isMounted) {
                setOptions(optionsData)
            }
        })
    // cleanup
    return () => isMounted = false
}

const isJson = (str: string) => {
    try {
        JSON.parse(str)
    } catch (e) {
        return false
    }
    return true
}